import React from 'react';

export const UploadIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M8.99994 17.75C8.58994 17.75 8.24994 17.41 8.24994 17V12.81L7.52994 13.53C7.23994 13.82 6.75994 13.82 6.46994 13.53C6.17994 13.24 6.17994 12.76 6.46994 12.47L8.46994 10.47C8.67994 10.26 9.00994 10.19 9.28994 10.31C9.56994 10.42 9.74994 10.7 9.74994 11V17C9.74994 17.41 9.40994 17.75 8.99994 17.75Z"
      fill="currentcolor"
    />
    <path
      d="M10.9999 13.75C10.8099 13.75 10.6199 13.68 10.4699 13.53L8.46994 11.53C8.17994 11.24 8.17994 10.76 8.46994 10.47C8.75994 10.18 9.23994 10.18 9.52994 10.47L11.5299 12.47C11.8199 12.76 11.8199 13.24 11.5299 13.53C11.3799 13.68 11.1899 13.75 10.9999 13.75Z"
      fill="currentcolor"
    />
    <path
      d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z"
      fill="currentcolor"
    />
    <path
      d="M22 10.75H18C14.58 10.75 13.25 9.41999 13.25 5.99999V1.99999C13.25 1.69999 13.43 1.41999 13.71 1.30999C13.99 1.18999 14.31 1.25999 14.53 1.46999L22.53 9.46999C22.74 9.67999 22.81 10.01 22.69 10.29C22.57 10.57 22.3 10.75 22 10.75ZM14.75 3.80999V5.99999C14.75 8.57999 15.42 9.24999 18 9.24999H20.19L14.75 3.80999Z"
      fill="currentcolor"
    />
  </svg>
);

export const TrashIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M17.5001 5.60833C17.4834 5.60833 17.4584 5.60833 17.4334 5.60833C13.0251 5.16667 8.62505 5 4.26672 5.44167L2.56672 5.60833C2.21672 5.64167 1.90839 5.39167 1.87505 5.04167C1.84172 4.69167 2.09172 4.39167 2.43339 4.35833L4.13339 4.19167C8.56672 3.74167 13.0584 3.91667 17.5584 4.35833C17.9001 4.39167 18.1501 4.7 18.1167 5.04167C18.0917 5.36667 17.8167 5.60833 17.5001 5.60833Z"
      fill="currentcolor"
    />
    <path
      d="M7.08363 4.76666C7.05029 4.76666 7.01696 4.76666 6.97529 4.75832C6.64196 4.69999 6.40863 4.37499 6.46696 4.04166L6.65029 2.94999C6.78363 2.14999 6.96696 1.04166 8.90863 1.04166H11.092C13.042 1.04166 13.2253 2.19166 13.3503 2.95832L13.5336 4.04166C13.592 4.38332 13.3586 4.70832 13.0253 4.75832C12.6836 4.81666 12.3586 4.58332 12.3086 4.24999L12.1253 3.16666C12.0086 2.44166 11.9836 2.29999 11.1003 2.29999H8.91696C8.03363 2.29999 8.01696 2.41666 7.89196 3.15832L7.70029 4.24166C7.65029 4.54999 7.38363 4.76666 7.08363 4.76666Z"
      fill="currentcolor"
    />
    <path
      d="M12.675 18.9583H7.325C4.41666 18.9583 4.3 17.35 4.20833 16.05L3.66666 7.65833C3.64166 7.31667 3.90833 7.01667 4.25 6.99167C4.6 6.975 4.89166 7.23334 4.91666 7.575L5.45833 15.9667C5.55 17.2333 5.58333 17.7083 7.325 17.7083H12.675C14.425 17.7083 14.4583 17.2333 14.5417 15.9667L15.0833 7.575C15.1083 7.23334 15.4083 6.975 15.75 6.99167C16.0917 7.01667 16.3583 7.30833 16.3333 7.65833L15.7917 16.05C15.7 17.35 15.5833 18.9583 12.675 18.9583Z"
      fill="currentcolor"
    />
    <path
      d="M11.3834 14.375H8.6084C8.26673 14.375 7.9834 14.0917 7.9834 13.75C7.9834 13.4083 8.26673 13.125 8.6084 13.125H11.3834C11.7251 13.125 12.0084 13.4083 12.0084 13.75C12.0084 14.0917 11.7251 14.375 11.3834 14.375Z"
      fill="currentcolor"
    />
    <path
      d="M12.0837 11.0417H7.91699C7.57533 11.0417 7.29199 10.7584 7.29199 10.4167C7.29199 10.075 7.57533 9.79169 7.91699 9.79169H12.0837C12.4253 9.79169 12.7087 10.075 12.7087 10.4167C12.7087 10.7584 12.4253 11.0417 12.0837 11.0417Z"
      fill="currentcolor"
    />
  </svg>
);

export const PdfIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M12.5003 18.9583H7.50033C2.97533 18.9583 1.04199 17.025 1.04199 12.5V7.50001C1.04199 2.97501 2.97533 1.04167 7.50033 1.04167H11.667C12.0087 1.04167 12.292 1.32501 12.292 1.66667C12.292 2.00834 12.0087 2.29167 11.667 2.29167H7.50033C3.65866 2.29167 2.29199 3.65834 2.29199 7.50001V12.5C2.29199 16.3417 3.65866 17.7083 7.50033 17.7083H12.5003C16.342 17.7083 17.7087 16.3417 17.7087 12.5V8.33334C17.7087 7.99167 17.992 7.70834 18.3337 7.70834C18.6753 7.70834 18.9587 7.99167 18.9587 8.33334V12.5C18.9587 17.025 17.0253 18.9583 12.5003 18.9583Z"
      fill="#353535"
    />
    <path
      d="M18.3337 8.95833H15.0003C12.1503 8.95833 11.042 7.85 11.042 5V1.66666C11.042 1.41666 11.192 1.18333 11.4253 1.09166C11.6587 0.991662 11.9253 1.05 12.1087 1.225L18.7753 7.89166C18.9503 8.06666 19.0087 8.34166 18.9087 8.575C18.8087 8.80833 18.5837 8.95833 18.3337 8.95833ZM12.292 3.175V5C12.292 7.15 12.8503 7.70833 15.0003 7.70833H16.8253L12.292 3.175Z"
      fill="#353535"
    />
    <path
      d="M10.833 11.4583H5.83301C5.49134 11.4583 5.20801 11.175 5.20801 10.8333C5.20801 10.4917 5.49134 10.2083 5.83301 10.2083H10.833C11.1747 10.2083 11.458 10.4917 11.458 10.8333C11.458 11.175 11.1747 11.4583 10.833 11.4583Z"
      fill="#353535"
    />
    <path
      d="M9.16634 14.7917H5.83301C5.49134 14.7917 5.20801 14.5083 5.20801 14.1667C5.20801 13.825 5.49134 13.5417 5.83301 13.5417H9.16634C9.50801 13.5417 9.79134 13.825 9.79134 14.1667C9.79134 14.5083 9.50801 14.7917 9.16634 14.7917Z"
      fill="#353535"
    />
  </svg>
);

export const InfoIconSvg: React.FC = () => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none">
    <g clip-path="url(#clip0_2199_1433)">
      <path
        d="M15.3039 19.0227C15.0279 19.0485 14.7508 18.9862 14.5123 18.8447C14.4263 18.7564 14.3613 18.6499 14.322 18.5331C14.2827 18.4163 14.2701 18.2921 14.2853 18.1697C14.2917 17.9634 14.3164 17.7581 14.3589 17.5561C14.4001 17.3244 14.4533 17.095 14.5185 16.8688L15.2425 14.3775C15.3172 14.1315 15.3666 13.8786 15.3898 13.6227C15.3898 13.3466 15.4266 13.1563 15.4266 13.0459C15.4342 12.8029 15.3869 12.5614 15.288 12.3393C15.1892 12.1172 15.0415 11.9204 14.8559 11.7634C14.3935 11.4084 13.8177 11.2339 13.2359 11.2725C12.8191 11.2787 12.4055 11.347 12.0087 11.475C11.575 11.61 11.1189 11.7715 10.6403 11.9597L10.4316 12.7697C10.5728 12.7207 10.7446 12.6654 10.9409 12.6041C11.1283 12.5486 11.3224 12.5196 11.5178 12.5182C11.7918 12.4885 12.0675 12.5558 12.2971 12.7084C12.3742 12.8004 12.4319 12.9071 12.4667 13.0221C12.5015 13.1371 12.5127 13.2579 12.4996 13.3772C12.4989 13.5836 12.4763 13.7893 12.4321 13.9909C12.3891 14.2057 12.3339 14.4327 12.2664 14.672L11.5362 17.1756C11.4773 17.4083 11.4302 17.6438 11.395 17.8813C11.3664 18.0846 11.352 18.2896 11.3521 18.4949C11.3506 18.7394 11.4051 18.981 11.5115 19.2012C11.6179 19.4214 11.7732 19.6143 11.9657 19.7651C12.4352 20.1257 13.0193 20.3044 13.6102 20.2683C14.0263 20.2769 14.441 20.2167 14.8375 20.0903C15.1852 19.9717 15.6495 19.8019 16.2305 19.581L16.4269 18.8078C16.2695 18.8731 16.1074 18.9264 15.9421 18.9674C15.7329 19.0151 15.5182 19.0337 15.3039 19.0227ZM16.071 7.21023C15.737 6.90352 15.297 6.73851 14.8437 6.75001C14.3906 6.7398 13.951 6.90463 13.6164 7.21023C13.003 7.73915 12.9345 8.66522 13.4634 9.27868C13.5106 9.33336 13.5617 9.38447 13.6164 9.43161C14.3152 10.0567 15.3721 10.0567 16.0709 9.43161C16.6843 8.89746 16.7486 7.96723 16.2144 7.35382C16.17 7.30269 16.122 7.25471 16.071 7.21023Z"
        fill="#113B65"
      />
      <path
        d="M13.5 0C6.04415 0 0 6.04415 0 13.5C0 20.9558 6.04415 27 13.5 27C20.9558 27 27 20.9558 27 13.5C27 6.04415 20.9558 0 13.5 0ZM13.5 25.7727C6.72195 25.7727 1.22729 20.2781 1.22729 13.5C1.22729 6.72195 6.72195 1.22729 13.5 1.22729C20.2781 1.22729 25.7727 6.72195 25.7727 13.5C25.7727 20.2781 20.2781 25.7727 13.5 25.7727Z"
        fill="#113B65"
      />
    </g>
    <defs>
      <clipPath id="clip0_2199_1433">
        <rect width="27" height="27" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ListCheckSvg: React.FC = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
    <g clip-path="url(#clip0_2347_186)">
      <path d="M12.5 3.75L5.625 10.625L2.5 7.5" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12.5 4L5.625 10.875L2.5 7.75" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_2347_186">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ToggleSvg: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M8 7H21" stroke="#4E5964" stroke-width="1.5" stroke-linecap="round" />
    <path d="M3 12H21" stroke="#4E5964" stroke-width="1.5" stroke-linecap="round" />
    <path d="M10 17H21" stroke="#4E5964" stroke-width="1.5" stroke-linecap="round" />
  </svg>
);
